import { render, staticRenderFns } from "./ServiceWidget.vue?vue&type=template&id=204a39f6"
import script from "./ServiceWidget.vue?vue&type=script&lang=js"
export * from "./ServiceWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports